import BuscarEmpresas from "@/pages/empresas/BuscarEmpresas.vue";
import DadosCadastroEmpresa from "@/pages/empresas/DadosCadastroEmpresa.vue";
import Empresas from "@/pages/empresas/Empresas.vue";
import EmpresasLote from "@/pages/empresas-lote/EmpresasLote.vue";
import InativacaoLote from "@/pages/inativacao-lote/InativacaoLote.vue";
import Prospects from "@/pages/empresas/Prospects.vue";
import BuscarGrupoEconomico from "@/pages/grupo-economico/BuscarGrupoEconomico";
import GrupoEconomico from "@/pages/grupo-economico/GrupoEconomico";
import Statuscadastros from "@/pages/status-cadastros/StatusCadastros.vue";

const routes = [
  {
    path: "/cadastros/empresas",
    name: "CadastroEmpresas",
    component: Empresas,
    meta: {
      auth: true,
      breadcrumb: new Array("Cadastro", "Empresa"),
      permissions: new Array(
        "CENTRAL_CADASTROS_CONSULTAR",
        "CENTRAL_CADASTROS_EDITAR",
        "CENTRAL_CADASTROS_APROVAR",
        "CENTRAL_CADASTROS_PARAMETRIZAR",
        "CENTRAL_CADASTROS_INATIVAR_LOTE"
      ),
    },
  },
  {
    path: "/cadastros/empresas/lote",
    name: "CadastroEmpresasLote",
    component: EmpresasLote,
    meta: {
      auth: true,
      breadcrumb: new Array("Cadastro", "Empresa", "Em Lote"),
      permissions: new Array(
        "CENTRAL_CADASTROS_CONSULTAR",
        "CENTRAL_CADASTROS_EDITAR",
        "CENTRAL_CADASTROS_APROVAR",
        "CENTRAL_CADASTROS_PARAMETRIZAR",
        "CENTRAL_CADASTROS_INATIVAR_LOTE"
      ),
    },
  },
  {
    path: "/cadastros/empresas/inativacao-lote",
    name: "CadastroInativacaoLote",
    component: InativacaoLote,
    meta: {
      auth: true,
      breadcrumb: new Array("Cadastro", "Empresa", "Inativação em Lote"),
      permissions: new Array("CENTRAL_CADASTROS_INATIVAR_LOTE"),
    },
  },
  {
    path: "/cadastros/buscar-empresas",
    name: "BuscarEmpresas",
    component: BuscarEmpresas,
    meta: {
      auth: true,
      breadcrumb: new Array("Empresas"),
      permissions: new Array(
        "CENTRAL_CADASTROS_CONSULTAR",
        "CENTRAL_CADASTROS_EDITAR",
        "CENTRAL_CADASTROS_APROVAR",
        "CENTRAL_CADASTROS_PARAMETRIZAR",
        "CENTRAL_CADASTROS_INATIVAR_LOTE"
      ),
    },
  },
  {
    path: "/cadastros/buscar-grupos-economicos",
    name: "BuscarGrupoEconomico",
    component: BuscarGrupoEconomico,
    meta: {
      auth: true,
      breadcrumb: new Array("Grupos Econômicos"),
      permissions: new Array(
        "CENTRAL_CADASTROS_CONSULTAR",
        "CENTRAL_CADASTROS_EDITAR",
        "CENTRAL_CADASTROS_APROVAR",
        "CENTRAL_CADASTROS_PARAMETRIZAR",
        "CENTRAL_CADASTROS_INATIVAR_LOTE"
      ),
    },
  },
  {
    path: "/cadastros/grupo-economico",
    name: "GrupoEconomico",
    component: GrupoEconomico,
    meta: {
      auth: true,
      breadcrumb: new Array("Grupos Econômicos"),
      permissions: new Array(
        "CENTRAL_CADASTROS_CONSULTAR",
        "CENTRAL_CADASTROS_EDITAR",
        "CENTRAL_CADASTROS_APROVAR",
        "CENTRAL_CADASTROS_PARAMETRIZAR",
        "CENTRAL_CADASTROS_INATIVAR_LOTE"
      ),
    },
  },
  {
    path: "/cadastros/status-cadastros",
    name: "Statuscadastros",
    component: Statuscadastros,
    meta: {
      auth: true,
      breadcrumb: new Array("Status dos Cadastros"),
      permissions: new Array(
        "CENTRAL_CADASTROS_CONSULTAR",
        "CENTRAL_CADASTROS_EDITAR",
        "CENTRAL_CADASTROS_APROVAR",
        "CENTRAL_CADASTROS_PARAMETRIZAR",
        "CENTRAL_CADASTROS_INATIVAR_LOTE"
      ),
    },
  },
  {
    path: "/cadastros/empresas/:id",
    redirect: "/cadastros/empresas/:id/dados_gerais",
  },
  {
    path: "/cadastros/empresas/:id/:aba",
    name: "CadastroEmpresasAba",
    component: Empresas,
    meta: {
      auth: true,
      breadcrumb: new Array("Cadastro", "Empresa"),
      permissions: new Array(
        "CENTRAL_CADASTROS_CONSULTAR",
        "CENTRAL_CADASTROS_EDITAR",
        "CENTRAL_CADASTROS_APROVAR",
        "CENTRAL_CADASTROS_PARAMETRIZAR",
        "CENTRAL_CADASTROS_INATIVAR_LOTE"
      ),
    },
  },
  {
    path: "/cadastros/pesquisa",
    name: "Pesquisa",
    component: DadosCadastroEmpresa,
    meta: {
      auth: true,
      breadcrumb: new Array("Gerenciamento dos Cadastros"),
      permissions: new Array(
        "CENTRAL_CADASTROS_CONSULTAR",
        "CENTRAL_CADASTROS_EDITAR",
        "CENTRAL_CADASTROS_APROVAR",
        "CENTRAL_CADASTROS_PARAMETRIZAR",
        "CENTRAL_CADASTROS_INATIVAR_LOTE"
      ),
    },
  },
  {
    path: "/cadastros/prospects",
    name: "Prospects",
    component: Prospects,
    meta: {
      auth: true,
      dadosFaltantes: false,
      breadcrumb: new Array("Prospects"),
      permissions: new Array(
        "CENTRAL_CADASTROS_CONSULTAR",
        "CENTRAL_CADASTROS_EDITAR",
        "CENTRAL_CADASTROS_APROVAR",
        "CENTRAL_CADASTROS_PARAMETRIZAR",
        "CENTRAL_CADASTROS_INATIVAR_LOTE"
      ),
    },
  },
];

export default routes;
